export default __webpack_public_path__ + "static/media/circle-user-solid-white.77a46893.svg";